var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.292969L8.14648 4.14652L8.85359 4.85363L11.5 2.20722L11.5 15.0001H12.5L12.5 2.20714L15.1465 4.85363L15.8536 4.14652L12 0.292969ZM19.9993 10.0001V20.0001C19.9993 20.5524 19.5516 21.0001 18.9993 21.0001H4.99927C4.44698 21.0001 3.99927 20.5524 3.99927 20.0001V10.0001C3.99927 9.44783 4.44698 9.00011 4.99927 9.00011H9V8.00011H4.99927C3.8947 8.00011 2.99927 8.89554 2.99927 10.0001V20.0001C2.99927 21.1047 3.8947 22.0001 4.99927 22.0001H18.9993C20.1038 22.0001 20.9993 21.1047 20.9993 20.0001V10.0001C20.9993 8.89554 20.1038 8.00011 18.9993 8.00011H15V9.00011H18.9993C19.5516 9.00011 19.9993 9.44783 19.9993 10.0001Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.c64dae72.svg";
export { ForwardRef as ReactComponent };